import MaterialList from "./components/material-listing-page";

const MaterialListPage = () => {
  return <MaterialList />;
};

export default MaterialListPage;
